import DeviceDetailsTab from './DeviceDetailsTab';


function Devices ({ tab, setSelectedTab, setPrefilledSystemId, userInfo, role }) {

    switch (tab) {
        case "Details":
            return <DeviceDetailsTab setSelectedTab={setSelectedTab} setPrefilledSystemId={setPrefilledSystemId} userInfo={userInfo} role={role} />;
        default:
            return <div className='tab-content'>Content for {tab}</div>;
    }
}

export default Devices;
